<template>
  <div>
    <div class="mb-[8px]">
      <template v-if="isImporting"> 数据导入中，请耐心等待 </template>
      <template v-else-if="status == IMPORT_STATUS.COMPLETE">
        数据导入完成<template v-if="failCount">，导入结果：校验未通过{{ failCount }}条</template>
      </template>
      <template v-else-if="status == IMPORT_STATUS.ERROR">
        数据导入异常，异常原因：{{ errorMsg }}
      </template>
    </div>
    <el-progress
      :percentage="percent"
      :indeterminate="isImporting"
      :striped="isImporting"
      striped-flow
      :duration="1"
      :status="
        status == IMPORT_STATUS.COMPLETE
          ? 'success'
          : status == IMPORT_STATUS.ERROR
            ? 'warning'
            : ''
      "
    ></el-progress>
    <div class="text-right mt-[8px]">
      <el-button v-if="!isImporting" size="small" type="primary" @click="handleOpenRecord"
        >查看导入记录</el-button
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { getImportResult } from '@/api'
import { IMPORT_STATUS } from './constant'
import { useUserStore } from '@/store/modules/user'

const props = defineProps({
  data: {
    type: Object
  },
  onFinish: {
    type: Function
  }
})

const taskName = computed(() => props.data?.taskName)

const percent = ref(0)
const status = ref(0)
const failCount = ref(0)
const errorMsg = ref('')

const isImporting = computed(() => {
  return status.value < IMPORT_STATUS.COMPLETE
})

// 轮询获取导入状态
const inter = ref()
const setPercent = () => {
  inter.value = setInterval(async () => {
    const { data } = await getImportResult(taskName.value)
    setImportStatus(data)
    // 结束循环
    if (data.currentStatus > IMPORT_STATUS.PENDING) {
      clearInterval(inter.value)
    }
  }, 1000)
}

// 设置当前状态
const setImportStatus = (data) => {
  percent.value = +(data.currentProgress * 100).toFixed()
  status.value = data.currentStatus
  failCount.value = data.failCount
  errorMsg.value = data.msg
  if (data.currentStatus > IMPORT_STATUS.PENDING) {
    percent.value = 100
  }
  if (
    data.currentStatus == IMPORT_STATUS.COMPLETE &&
    props.onFinish &&
    typeof props.onFinish == 'function'
  ) {
    setTimeout(() => {
      props.onFinish()
    }, 2000)
  }
}

// 查看导入记录
const userStore = useUserStore()
const importRecordRef = computed(() => userStore.getImportRecordRef)
const handleOpenRecord = () => {
  importRecordRef.value?.openRecord(taskName.value)
  if (props.onFinish && typeof props.onFinish == 'function') {
    props.onFinish()
  }
}

onMounted(() => {
  setImportStatus(props.data)
  if (isImporting.value) {
    setPercent()
  }
})
</script>
